import axios from 'axios'
import ParamUtils from '@/core/utils/ParamUtils'
const urlDownloadVirtualizacao = '/compra-direta/api/v1/fornecedor/virtualizacao/download?'
const urlBaseFornecedor = '/compra-direta/api/v1/fornecedor/compras-diretas'

class FornecedorComprasDiretasApiClient {

    async decidirNegociacaoLoteOuItemDoReajuste(compraDiretaId, id, itemOuLoteReajusteId, itemOuLoteCompraDiretaId, tipo, aceito, valor) {
        return axios.put(`/compra-direta/api/v1/fornecedor/compras-diretas/${compraDiretaId}/negociacoes/${id}`, {
            elementoReajusteId: itemOuLoteReajusteId,
            elementoCompraDiretaId: itemOuLoteCompraDiretaId,
            tipo: tipo,
            aceito: aceito,
            valor: valor
        })
    }

    async adicionarAnexoDocumentoSolicitado(compraDiretaId, arquivo) {
        const uri = arquivo.anexo.uri
        const documentoSolicitadoId = arquivo.documentoSolicitadoId
        return await axios.post(`/compra-direta/api/v1/fornecedor/compras-diretas/${compraDiretaId}/fornecedores/documentos/${documentoSolicitadoId}?uri=${uri}`)
    }

    /**
     *  TODO Repensar uma forma de não chumbar o noProcessoDigital
     * @param documentoVirtualizadoId
     * @param opcaoDownloadVirtualizacao
     * @param nomeArquivo
     * @param noProcessoDigital
     * @returns {Promise<AxiosResponse<unknown>>}
     */
    async baixarRelatorioDeProtocolos(documentoVirtualizadoId, opcaoDownloadVirtualizacao, nomeArquivo, noProcessoDigital) {
        const paramObj = {
            documentoVirtualizadoId: documentoVirtualizadoId,
            nomeArquivo: nomeArquivo,
            opcaoDownloadVirtualizacao: opcaoDownloadVirtualizacao
        }
        return await axios.get(`${urlDownloadVirtualizacao}noProcessoDigital=true&`+ ParamUtils.ObjectsToParams([paramObj]),
            {
                responseType: 'arraybuffer'
            }
        )
    }

    async baixarRelatorioTermoVirtualizado(dados) {
        const { compraDiretaId, ...paramsObj } = dados
        return await axios.get(`/compra-direta/api/v1/compras-direta/${compraDiretaId}/documentos-virtualizados/download?` + ParamUtils.ObjectsToParams([paramsObj]),
            {
                responseType: 'arraybuffer'
            }
        )
    }

    async baixarRelatorioDeProtocolosPreview(compraDiretaId, propostaId) {
        return await axios.get(`/compra-direta/api/v1/fornecedor/compras-diretas/${compraDiretaId}/propostas/${propostaId}`,
            {
                responseType: 'arraybuffer'
            })
    }

    async baixarRelatorioDeReajustes(documentoVirtualizadoId, opcaoDownloadVirtualizacao, nomeArquivo){
        const paramObj = {
            documentoVirtualizadoId,
            nomeArquivo,
            opcaoDownloadVirtualizacao
        }
        return await axios.get(`${urlDownloadVirtualizacao}noProcessoDigital=true&`+ ParamUtils.ObjectsToParams([paramObj]),
            {
                responseType: 'arraybuffer'
            }
        )
    }

    async baixarRelatorioDeReajustesNaoVirtualizado(compraDiretaId){
        return await axios.get(`/compra-direta/api/v1/fornecedor/compras-diretas/${compraDiretaId}/relatorio-reajuste`,
            {
                responseType: 'arraybuffer'
            }

        )
    }

    async buscarComprasDiretasEncerradas(filtros, paginacao) {
        return await axios.get('/compra-direta/api/v1/fornecedor/compras-diretas/encerradas' +
            `?${ParamUtils.ObjectsToParams([paginacao, filtros])}`)
    }

    async buscarDetalhes(compraDiretaId) {
        return await axios.get(`/compra-direta/api/v1/fornecedor/compras-diretas/${compraDiretaId}/detalhes`)
    }

    async buscarDocumentosSolicitados(compraDiretaId) {
        return await axios.get(`/compra-direta/api/v1/fornecedor/compras-diretas/${compraDiretaId}/fornecedores/documentos`)
    }

    async buscarItensELotesDaProposta(compraDiretaId) {
        return await axios.get(`/compra-direta/api/v1/fornecedor/compras-diretas/${compraDiretaId}/propostas`)
    }

    async buscarItensELotesVencedoresAReajustar(compraDiretaId) {
        return await axios.get(`/compra-direta/api/v1/fornecedor/compras-diretas/${compraDiretaId}/fornecedores/reajuste-proposta`)
    }

    async buscarLancesDaCompraDireta(compraDiretaId, propostaId) {
        return await axios.get(`/compra-direta/api/v1/fornecedor/compras-diretas/${compraDiretaId}/propostas/${propostaId}/lances`)
    }

    async buscarMeusLotesItensVencedores(compraDiretaId) {
        return await axios.get(`/compra-direta/api/v1/fornecedor/compras-diretas/${compraDiretaId}/resultado/meus`)
    }

    async buscarMinhasComprasDiretas(filtros, paginacao) {
        return await axios.get('/compra-direta/api/v1/fornecedor/compras-diretas/participando?'
            + ParamUtils.ObjectsToParams([filtros, paginacao]))
    }

    async buscarComprasDiretasMeuinteresse(filtros, paginacao) {
        return await axios.get('/compra-direta/api/v1/fornecedor/compras-diretas/meu-interesse?'
            + ParamUtils.ObjectsToParams([filtros, paginacao]))
    }

    async buscarComprasDiretasDisponiveis(filtros, paginacao) {
        return await axios.get('/compra-direta/api/v1/fornecedor/compras-diretas/abertas' +
            `?${ParamUtils.ObjectsToParams([paginacao, filtros])}`)
    }

    async buscarResumoProposta(compraDiretaId, propostaId) {
        const params = {}

        if (propostaId != null) {
            params.propostaId = propostaId
        }
        return await axios.get(`/compra-direta/api/v1/fornecedor/compras-diretas/${compraDiretaId}/propostas/resumo-compra-direta`,
            { params })
    }

    async buscarResultadoLotesItens(compraDiretaId) {
        return await axios.get(`/compra-direta/api/v1/fornecedor/compras-diretas/${compraDiretaId}/resultado/todos`)

    }

    async buscarTermos(compraDiretaId) {
        return await axios.get(`/compra-direta/api/v1/fornecedor/compras-diretas/${compraDiretaId}/buscar-termo`)
    }

    async criarTermos(compraDiretaId) {
        return await axios.post(`/compra-direta/api/v1/fornecedor/compras-diretas/${compraDiretaId}/termo`)
    }

    async cancelarEnvioDaPropostaSemDisputa(compraDiretaId, propostaId, numeroProtocolo) {
        const paramObj = {numeroProtocolo: numeroProtocolo}
        return await axios.post(`/compra-direta/api/v1/fornecedor/compras-diretas/${compraDiretaId}/propostas/${propostaId}/cancelar-sem-disputa?`+
            ParamUtils.ObjectsToParams([paramObj]), {
            numeroProtocolo: numeroProtocolo
        })
    }

    async cancelarEnvioDaPropostaComDisputa(compraDiretaId, propostaId, numeroProtocolo) {
        const paramObj = {numeroProtocolo: numeroProtocolo}
        return await axios.post(`/compra-direta/api/v1/fornecedor/compras-diretas/${compraDiretaId}/propostas/${propostaId}/cancelar-com-disputa?`+
            ParamUtils.ObjectsToParams([paramObj]), {
            numeroProtocolo: numeroProtocolo,
            propostaId: propostaId,
            compraDiretaId: compraDiretaId
        })
    }

    async cancelarLance(compraDiretaId, propostaId, item) {
        return await axios.put(`/compra-direta/api/v1/fornecedor/compras-diretas/${compraDiretaId}/propostas/${propostaId}/lances/cancelar`, item)
    }

    async cancelarLanceDesempate(compraDiretaId, requestBody) {
        return await axios.put(`${urlBaseFornecedor}/${compraDiretaId}/resultados/desempatar/cancelar-lances`, requestBody)
    }

    async efetuarLance(compraDiretaId, propostaId, dados) {
        return await axios.post(`/compra-direta/api/v1/fornecedor/compras-diretas/${compraDiretaId}/propostas/${propostaId}/lances`, dados)
    }

    async efetuarLanceDesempate(requisicaoData) {
        const { compraDiretaId, ...dados } = requisicaoData
        return await axios.post(`${urlBaseFornecedor}/${compraDiretaId}/resultados/desempatar/enviar-lances`, dados)
    }

    async enviarProposta(compraDiretaId, propostaId, validarMargem) {
        return await axios.post(`/compra-direta/api/v1/fornecedor/compras-diretas/${compraDiretaId}/propostas/${propostaId}?validarMargem=${validarMargem}`)
    }

    async enviarDocumentosAnalise(compraDiretaId) {
        return await axios.post(`/compra-direta/api/v1/fornecedor/compras-diretas/${compraDiretaId}/fornecedores/documentos/enviar`)
    }

    async enviarReajusteLote(compraDiretaId, loteCompraDiretaId) {
        return await axios.put(`/compra-direta/api/v1/fornecedor/compras-diretas/${compraDiretaId}/reajuste-lote-proposta/${loteCompraDiretaId}`,
            {compraDiretaId, loteCompraDiretaId})
    }

    async removerProposta(compra) {
        return await axios.delete(`/compra-direta/api/v1/fornecedor/compras-diretas/${compra.id}/propostas/${compra.propostaId}`)
    }

    async removerDocumentoApresentado(compraDiretaId, documentoApresentadoId) {
        return await axios.delete(`/compra-direta/api/v1/fornecedor/compras-diretas/${compraDiretaId}/fornecedores/documentos-apresentados/${documentoApresentadoId}`)
    }

    async salvarTermos(compraDiretaId, propostaId, termos) {
        return await axios.put(`/compra-direta/api/v1/fornecedor/compras-diretas/${compraDiretaId}/propostas/${propostaId}/termo`, termos)
    }

    async salvarValorIndividual(itemProposta) {
        return await axios.put(`/compra-direta/api/v1/fornecedor/item-proposta/${itemProposta.propostaItemId}`, itemProposta)
    }

    async salvarItemDoReajuste(compraDiretaId, item) {
        return await axios.put(`/compra-direta/api/v1/fornecedor/compras-diretas/${compraDiretaId}/resultado/item/atualizar`, item)
    }

    async verificarSePossuiLoteItemVencedor(compraDiretaId) {
        return await axios.get(`/compra-direta/api/v1/fornecedor/compras-diretas/${compraDiretaId}/fornecedor/vencedor`)
    }

    async validarParaProposta(compraDiretaId) {
        return await axios.get(`/compra-direta/api/v1/fornecedor/compras-diretas/${compraDiretaId}/termo/validar-fornecedor`)
    }

    async atualizarLotePropostaMaiorDesconto(lotePropostaId, lote){
        return await axios.put(`/compra-direta/api/v1/fornecedor/lote-proposta/${lotePropostaId}`, lote)
    }

    async baixarTermoAceiteProposta(propostaId){
        return await axios.get(`/compra-direta/api/v1/propostas/${propostaId}/baixar-relatorio-termo`,
            {responseType: 'arraybuffer'})
    }

    async atualizarReadequacaoItemLote(dados){
        const {compraDiretaId, itemOuLoteId} = dados
        return await axios.put(`/compra-direta/api/v1/fornecedor/compras-diretas/${compraDiretaId}/itens-lotes/${itemOuLoteId}/atualizar-readequacao`, dados)
    }

    async buscarNotificacoesFornecedor(input) {
        return await axios.get(`/compra-direta/api/v1/fornecedor/notificacoes?${ParamUtils.ObjectToParams(input)}`)
    }

    async contarNotificacoesNaoLidas(input) {
        return await axios.get(`/compra-direta/api/v1/fornecedor/notificacoes/contar-nao-lidas?${ParamUtils.ObjectToParams(input)}`)
    }

    async buscarNotificacoesChatFornecedor(input) {
        return await axios.get(`/compra-direta/api/v1/fornecedor/compras-diretas/chat/notificacoes?${ParamUtils.ObjectToParams(input)}`)
    }

    async buscarConversacaoChatMesnagens(compraDiretaId, dados) {
        return await axios.get(`/compra-direta/api/v1/fornecedor/compras-diretas/${compraDiretaId}/chat/mensagens?${ParamUtils.ObjectToParams(dados)}`)
    }

    async buscarItemLoteLancesDesempate(compraDiretaId) {
        return await axios.get(`${urlBaseFornecedor}/${compraDiretaId}/resultados/desempatar/itens-lotes`)
    }
}

export default new FornecedorComprasDiretasApiClient()
